// extracted by mini-css-extract-plugin
export var content = "CoachsCornerItem-module--content--3ryst";
export var contentImage = "CoachsCornerItem-module--content-image--FA21R";
export var contentImageInner = "CoachsCornerItem-module--content-image-inner--zfeS+";
export var contentImageInnerGlow = "CoachsCornerItem-module--content-image-inner-glow--OqDXF";
export var contentImageInnerPattern = "CoachsCornerItem-module--content-image-inner-pattern--RuzAa";
export var contentPrint = "CoachsCornerItem-module--content-print--aTmbL";
export var contentTitle = "CoachsCornerItem-module--content-title--hTpl4";
export var even = "CoachsCornerItem-module--even--45JRL";